'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.report = void 0;
var report = {
    stat: function (t, r) {
        grounds.stat(t, r);
    },
    pageStat: function (t) {
        grounds.pageStat(JSON.stringify(t));
    },
    actionStat: function (t) {
        var r = t.type, e = t.id, n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        grounds.actionStat(JSON.stringify(Object.assign({
            type: r,
            id: e
        }, n)));
    },
    expose: function (t, r, e, n) {
        var o = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : '';
        grounds.expose(JSON.stringify({
            id: t,
            rumn: r,
            reftype: e,
            ch: n,
            src: o
        }));
    },
    vStat: function (t, r) {
        grounds.vStat(JSON.stringify(t), r);
    }
};
exports.report = report;